import * as React from 'react';
import { useForecastStore } from 'src/hooks/forecast';

const LastForecastReceived = (props) => {
    const [{ last_forecast_receive_date }, { }] = useForecastStore();

    return (
        <>
            {
                last_forecast_receive_date &&
                <div className='col-auto d-flex ms-auto'>
                    <div className='bs5 text-end'>
                        <div className='font-bold'>Last Forecast Received</div>
                        <div>{last_forecast_receive_date}</div>
                    </div>
                </div>
            }
        </>
    );
}

export default LastForecastReceived;